/*function eventFilter() {
    // Declare variables
    var posts, content, i, filter, input;
    posts = document.querySelectorAll('[id^="post-"]');
    input = document.getElementById("eventFilterInput");
    filter = input.value.toUpperCase();
    // Loop through all table rows, and hide those who don't match the search query
    for (var i = 0; i < posts.length; i++) {
        content = posts[i].getElementsByTagName("td")[0];
        if (posts[i].innerHTML.toUpperCase().indexOf(filter) > -1) {
            posts[i].style.display = "";
        } else {
            posts[i].style.display = "none";
        } 
    }
}*/


(function($) {
    
    $(document).on('change', 'select[name=tribe__ecp_custom_16]',function(evt){
        if(/^(2[0-9]{3})$/.test(this.value)){
            var currentVal = $('input[name=tribe-bar-date]').val();
            var currentYear = currentVal.substring(0, 4);
            if(currentYear != this.value){
                $('input[name=tribe-bar-date]').val(this.value+"-01-01");  
            }
        }
    });
    
    $(document).on('change', 'input[name=tribe-bar-date]',function(evt){
        if(/^(2[0-9]{3}).*/.test(this.value)){
            var currentVal = $('select[name=tribe__ecp_custom_16]').val();
            var currentYear = currentVal.substring(0, 4);
            if(currentYear != this.value){
                $('select[name=tribe__ecp_custom_16]').val('select');  
            }
        }
    });
    
})(jQuery);